import React, { useState, useEffect } from 'react';
import { Row, Col } from 'reactstrap';
import { translate } from 'react-jhipster';
import { stringify } from 'querystring';
import { ButonDisabled } from './ButonDisabled';

export const SelectableButtonsItem = props => {
  const [selected, setSelected] = useState(false);

  const selectedColor = 'primary';
  const [cssColor, setCssColor] = useState(selectedColor);

  const handleSelectClick = e => {};

  useEffect(() => {}, []);

  console.warn(props.setAvailable);
  return (
    <Row style={selected ? { backgroundColor: '#59a3fb' } : {}} onClick={handleSelectClick}>
      <Col>
        <Row>
          <Col>{props.item.image ? <img width="40" src={props.item.image}></img> : null}</Col>
          <Col>
            <ButonDisabled
              css={cssColor}
              disableCss="selectButton selectButtonDisable"
              onClick={() => props.onClick(props.item.selected)}
              disabled={false}
            >
              <i className="fas fa-backward"></i>
              {translate(props.item.text)}
            </ButonDisabled>
          </Col>
        </Row>
        <Row>
          <Col style={{ textAlign: 'left' }}>ffff</Col>
        </Row>
      </Col>
      <Col md="1">
        {/* <input
                name="isGoing"            
                type="checkbox"
                 
                />  */}
      </Col>
    </Row>

    // <Button {...this.props}   />
  );
};
